import {Component, OnInit} from '@angular/core';
import {DisinfectionprogramService} from '@services/disinfectionprogram.service';
import {ToastrService} from 'ngx-toastr';

@Component({
    selector: 'app-disinfection-list',
    templateUrl: './disinfection-list.component.html',
    styleUrl: './disinfection-list.component.scss'
})
export class DisinfectionListComponent implements OnInit {
    public disinfections = [];
    public totalRecords = 0;
    public loading = true;
    public userDetail: any;
    public disinfectionProgramList: any[] = [];
    public disinfectionTypeOptions: {value: any; label: string}[] = [];
    public filterConfig: any;

    public displayDeleteDialog: boolean = false;
    public selectedDisinfectionId: number = 0;

    private filterProgramName: string = '';
    private filterDisinfectionTypeId: number | undefined;

    constructor(
        private disinfectionService: DisinfectionprogramService,
        private toastr: ToastrService
    ) {}

    ngOnInit(): void {
        this.userDetail = JSON.parse(localStorage.getItem('UserDetail'));
        this.initializeFilterConfig();
        this.getDisInfectionProgramList();
        this.loadDisinfectionList({first: 0, rows: 10});
    }

    initializeFilterConfig(): void {
        this.filterConfig = {
            fields: [
                {
                    key: 'programName',
                    label: 'Program Name',
                    type: 'text'
                },
                {
                    key: 'disinfectionType',
                    label: 'Disinfection Type',
                    type: 'select',
                    options: this.disinfectionTypeOptions
                }
            ]
        };
    }

    onFilterChange(filters: any): void {
        this.filterProgramName = filters.programName || '';
        this.filterDisinfectionTypeId = filters.disinfectionType || undefined;

        this.loadDisinfectionList({first: 0, rows: 10});
    }

    onFilterClear(): void {
        this.filterProgramName = '';
        this.filterDisinfectionTypeId = undefined;
        this.loadDisinfectionList({first: 0, rows: 10});
    }

    loadDisinfectionList(event: any): void {
        this.loading = true;
        const page = event.first / event.rows + 1; // PrimeNG uses zero-based indexing
        const pageSize = event.rows;

        this.disinfectionService
            .getDisInfectionList(
                this.userDetail.id,
                page,
                pageSize,
                this.filterProgramName,
                this.filterDisinfectionTypeId
            )
            .subscribe((response) => {
                this.disinfections = response.disInfections;
                this.totalRecords = response.totalRecords;

                if (!this.disinfections || this.disinfections.length === 0) {
                    this.toastr.warning('No Records Found');
                }

                this.loading = false;
            });
    }

    getDisInfectionProgramList(): void {
        this.disinfectionService
            .getDisInfectionProgramList()
            .subscribe((result) => {
                this.disinfectionProgramList = result;
                this.disinfectionTypeOptions = result.map((item) => ({
                    value: item.id,
                    label: item.name
                }));
                this.filterConfig = {
                    ...this.filterConfig,
                    fields: this.filterConfig.fields.map((field) =>
                        field.key === 'disinfectionType'
                            ? {...field, options: this.disinfectionTypeOptions}
                            : field
                    )
                };
            });
    }

    deleteDisinfection(id: number): void {
        this.selectedDisinfectionId = id;
        this.displayDeleteDialog = true;
    }

    deleteItem(): void {
        if (this.selectedDisinfectionId) {
            this.disinfectionService
                .deleteDisinfectionProgram(this.selectedDisinfectionId)
                .subscribe({
                    next: (response) => {
                        this.displayDeleteDialog = false;
                        this.selectedDisinfectionId = 0;
                        this.toastr.success(
                            'Disinfection Program deleted successfully.'
                        );
                        this.loadDisinfectionList({first: 0, rows: 10});
                    },
                    error: (error) => {
                        this.toastr.error(
                            error?.error?.message ||
                                'Failed to delete disinfection program.'
                        );
                        this.displayDeleteDialog = false;
                        this.selectedDisinfectionId = 0;
                    }
                });
        }
    }
}
